export default {
    appkey: process.env.VUE_APP_KEY,
    domain: process.env.VUE_APP_CRM_APP
};
